module.exports = __webpack_public_path__ + "004509374b25f2e50479416ddff59c65.ttf";